import React from 'react';
import moment from 'moment';
import {BOOKING_TYPES} from '../../../common/config';
import BookingDetails from '../../BookingDetails';
import AppointmentBookingLocation from './AppointmentBookingLocation';

const BookingDateTimeUI = ({
  bookingType,
  bookingDetails,
  repeatIdClasses,
  isRepeatClass,
  scheduleNotices = [],
  members,
}) => {
  const appointment = bookingType === BOOKING_TYPES.APPOINTMENT;
  const dates = isRepeatClass ? repeatIdClasses || [] : [];
  const first = dates[0] || bookingDetails?.classDetails;
  const last = dates[dates.length - 1] || first;
  const start = appointment
    ? moment(
        `${bookingDetails?.trainingTime?.date} ${bookingDetails?.trainingTime?.time}`,
        'YYYY-MM-DD HH:mm'
      ).format()
    : first?.start_branch_time;
  const end =
    appointment && start && moment(start).isValid()
      ? moment(start)
          .add(bookingDetails?.service?.duration || 0, 'minutes')
          .format()
      : first?.end_branch_time;
  return (
    <>
      <BookingDetails
        service={
          appointment
            ? bookingDetails?.service?.serviceName
            : bookingDetails?.classDetails?.commonT || bookingDetails?.classDetails?.serviceName
        }
        members={members}
        memberLabel={appointment ? 'Member Booked' : 'Members'}
        coach={
          bookingDetails?.trainer?.trainerName ||
          bookingDetails?.classDetails?.selectedTrainers
            ?.map(t => t.trainerName)
            .filter(Boolean)
            .join(', ')
        }
        start={start}
        end={end}
        date={
          isRepeatClass
            ? dates.length
              ? `${moment(start).format('MMMM Do, YYYY')} – ${moment(
                  last?.end_branch_time || last?.start_branch_time
                ).format('MMMM Do, YYYY')}`
              : 'No available dates'
            : undefined
        }
        time={isRepeatClass && !dates.length ? 'No available times' : undefined}
        booking={bookingDetails?.classDetails}
        location={
          appointment ? (
            <AppointmentBookingLocation
              companyId={bookingDetails?.service?.companyId}
              trainerId={bookingDetails?.trainer?.branchTrainersTrainerId}
              branchId={bookingDetails?.trainer?.branchTrainersBranchId}
            />
          ) : undefined
        }
      />
      {scheduleNotices.map(notice => (
        <div className="alert alert-info mt-3 mb-0" role="status" key={notice}>
          {notice}
        </div>
      ))}
    </>
  );
};
export default BookingDateTimeUI;
